import AwardsDataBuilder from './AwardsDataBuilder';
import CategoryTally from './CategoryTally';

class AwardsCategoryData extends AwardsDataBuilder {
  constructor(data = {}, totals = {}, awardNames = []) {
    super(data, totals, awardNames, AwardsCategoryData.buildCategoriesTallyObservable);
  }

  static buildCategoriesTallyObservable(data) {
    return Object.entries(data)
      .map(([category, categoryData]) => CategoryTally.fromObjectObservable(categoryData, category));
  }
}

export default AwardsCategoryData;
